import { capitalize, formatMoney, toLocalTimeZoneStringDate } from 'utils/helpers';
import { FormState } from 'react-hook-form';
import { LEDGER_CODE_PRORATION_AMOUNT, LEDGER_CODE_PRORATION_PERDIEM, LEDGER_CODE_PRORATION_PRORATED } from 'utils/constants';
import { Proration, ScheduleProrationEnum } from 'v2-types/order';
import { PerDiemDecimals, ProrationForm, ProrationsForm } from '../types';

export const perDiemDecimals: PerDiemDecimals[] = [
  { value: 2, name: '2' },
  { value: 3, name: '3' },
  { value: 4, name: '4' },
  { value: 5, name: '5' },
  { value: 6, name: '6' },
  { value: 7, name: '7' },
  { value: 8, name: '8' },
  { value: 9, name: '9' },
];

export const paymentScheduleOptions = Object.values(ScheduleProrationEnum)
  .filter((schedule) => !schedule.includes('custom'))
  .map((schedule) => ({
    value: schedule,
    name: capitalize(schedule).replaceAll("_", ' '),
  }))
  .sort((scheduleA, scheduleB) => scheduleA.name.localeCompare(scheduleB.name));

export const defaultTabs = ['County Taxes', 'City/Town Taxes', 'Assessments'];

export const getPropertyProrationForms = (propertyId: string, prorations: Proration[]) => {
  if (!prorations) return [];

  const propertyProrations: ProrationForm[] =
    prorations
      .filter((proration) => proration.estate._id === propertyId)
      .map((proration) => {
        const anualAmount = proration.accounting.find((entry) => entry.code.includes(LEDGER_CODE_PRORATION_AMOUNT));
        const perDiemAmount = proration.accounting.find((entry) => entry.code.includes(LEDGER_CODE_PRORATION_PERDIEM));
        const proratedAmount = proration.accounting.find((entry) => entry.code.includes(LEDGER_CODE_PRORATION_PRORATED));

        const end_date = toLocalTimeZoneStringDate(proration.end_date);
        const start_date = toLocalTimeZoneStringDate(proration.start_date);
        const proration_date = toLocalTimeZoneStringDate(proration.proration_date);

        return {
          ...proration,
          anualAmount,
          perDiemAmount,
          proratedAmount,
          end_date,
          start_date,
          proration_date
        };
      }).sort((a, b) => {
        const ix = defaultTabs.indexOf(a.description);
        const iy = defaultTabs.indexOf(b.description);
        if (ix === -1 && iy === -1) return 0;
        if (ix === -1) return 1;
        if (iy === -1) return -1;
        return ix - iy;
      }) ?? [];

  return propertyProrations;
};

export const getProrationFormTitle = (form?: ProrationForm) => {
  let title = 'Prorated Amount';
  if (form) {
    const { perDiemAmount, decimals, kind: prorateUsing, days } = form;
    if (prorateUsing === 'per_diem') {
      if (days !== null && days !== undefined && perDiemAmount) {
        title += ` (${days} days times ${formatMoney(perDiemAmount.amount ?? 0, decimals)})`;
      }
    }
  }

  return title;
};

export const getDefaultProratedAmount = (formState: FormState<ProrationsForm>, formIndex: number) => {
  const { defaultValues } = formState;
  if (!defaultValues) return null;

  const { forms } = defaultValues;

  const form = forms && forms.length > 0 ? forms[formIndex!] as ProrationForm : undefined;
  if (!form || !form.proratedAmount) return null;

  return form.proratedAmount.amount;
};
